<template>
  <article>
    <h1 class="text-h3" id="intro" v-intersect="onIntersect">Applications</h1>
    <p>
      Applications help analyze data within files, datasets and/or predictions. 
    </p>
    <p>
      There are different applications available within this system &mdash; some process files or datasets, while others work
      with predicted outputs. The purpose of an application is to process and/or analyze data.
    </p>

    <p>
      Applications are classified as <code>online</code> and <code>offline</code> depending on whether they predict in real-time or not. 
      Offline applications only deal with predictions, while online applications can predict in real-time and only deal with files and datasets. 
    </p>

    <h2 class="text-h4" id="forecasting" v-intersect="onIntersect">Production Forecasting</h2>
    <p>
      <router-link :to="{ path: '/help/applications/forecasting' }">Production Forecasting</router-link>
      analyzes long-term production forecasts to generate type curves and reserves estimates. 
    </p>
    <v-card flat outlined color="grey" :to="{ path: '/help/applications/forecasting' }"><v-img eager contain src="@/assets/images/forecasting.png"></v-img></v-card>
    
    <h2 class="text-h4" id="holdback" v-intersect="onIntersect">Holdback Testing</h2>
    <p>
      <router-link :to="{ path: '/help/applications/holdback' }">Holdback Testing</router-link>
      helps analyze the quality of predictions between actual and predicted production.
    </p>
    <v-card flat outlined color="grey" :to="{ path: '/help/applications/holdback' }"><v-img eager contain src="@/assets/images/holdback.png"></v-img></v-card>
    
    <h2 class="text-h4" id="predict" v-intersect="onIntersect">Ducs and Permits</h2>
    <p>
      <router-link :to="{ path: '/help/applications/predict' }">Ducs and Permits</router-link>
      also analyzes long-term production forecasts, but uses predictions generated with well completion data only.
    </p>
    <v-card flat outlined color="grey" :to="{ path: '/help/applications/predict' }"><v-img eager contain src="@/assets/images/forecasting.png"></v-img></v-card>

    <h2 class="text-h4" id="virtualwell" v-intersect="onIntersect">Virtual Well</h2>
    <p>
      <router-link :to="{ path: '/help/applications/virtualwell' }">Virtual Well</router-link>
      helps generate probable reserve estimates of new wells depending on well location and completion information.
    </p>
    <v-card flat outlined color="grey" :to="{ path: '/help/applications/virtualwell' }"><v-img eager contain src="@/assets/images/virtual.png"></v-img></v-card>

    <contents :items="menu" ref="contents" />
  </article>
</template>
<script>
import Contents from "@/components/contents"
export default {
  name: "HelpApplications",
  components: { Contents },
  data() {
    return {
      menu: [
        { id: "intro", text: "Introduction", depth: 1 },
        { id: "forecasting", text: "Forecasting", depth: 1 },
        { id: "holdback", text: "Holdback Analysis", depth: 1 },
        { id: "predict", text: "Ducs and Permits", depth: 1 },
        { id: "virtualwell", text: "Virtual Well", depth: 1 }
      ]
    }
  }
}
</script>
